import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import { allLinks, removeQuoteLink } from 'components/consumer/CustomerDashboardPageTemplate/components/CustomerDashboardLinks/CustomerDashboardLinksUI';
const stripTrailingSlash = path => path.endsWith('/') ? path.slice(0, -1) : path;
const CustomerDashboardNavLinksUI = t0 => {
  const $ = _c(10);
  const {
    currentPath,
    items: t1,
    showQuoteLink: t2
  } = t0;
  let t3;
  let t4;
  if ($[0] !== currentPath || $[1] !== t1 || $[2] !== t2) {
    const items = t1 === undefined ? [] : t1;
    const showQuoteLink = t2 === undefined ? false : t2;
    t3 = "flex flex-col list-none ml-0";
    let t5;
    if ($[5] !== currentPath) {
      t5 = t6 => {
        const {
          label,
          path
        } = t6;
        const isSelected = currentPath.startsWith(stripTrailingSlash(path));
        return <li key={path}><Link aria-current={isSelected ? "page" : undefined} className={classNames("text-base !text-gray flex px-11 py-3 no-underline hover:[border-top:1px_solid_#f1f1f1] hover:[border-bottom:1px_solid_#f1f1f1] hover:[border-left:8px_solid_#107c8c] hover:!no-underline", {
            "font-normal [border-top:1px_solid_transparent] [border-bottom:1px_solid_transparent] [border-left:8px_solid_transparent]": !isSelected,
            "font-bold [border-top:1px_solid_#f1f1f1] [border-bottom:1px_solid_#f1f1f1] [border-left:8px_solid_#107c8c] !no-underline bg-white": isSelected
          })} to={path}>{label}</Link></li>;
      };
      $[5] = currentPath;
      $[6] = t5;
    } else {
      t5 = $[6];
    }
    t4 = items.filter(showQuoteLink ? allLinks : removeQuoteLink).map(t5);
    $[0] = currentPath;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
  } else {
    t3 = $[3];
    t4 = $[4];
  }
  let t5;
  if ($[7] !== t3 || $[8] !== t4) {
    t5 = <ul className={t3}>{t4}</ul>;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
};
CustomerDashboardNavLinksUI.propTypes = {
  currentPath: PropTypes.string,
  items: PropTypes.shape({
    label: PropTypes.string,
    path: PropTypes.string
  }),
  showQuoteLink: PropTypes.bool
};
export default CustomerDashboardNavLinksUI;